import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { TooltipData } from './users-stats-chart-tooltip-data';

@Component({
    selector: 'users-stats-chart-tooltip',
    templateUrl: './users-stats-chart-tooltip.component.html',
    styleUrls: ['./users-stats-chart-tooltip.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UsersStatsChartTooltipComponent implements OnInit {

  @Input()
  model: TooltipData;


  constructor() {
    // console.log("constructor()");
  }

  ngOnInit() {
    // console.log("ngOnInit()");
  }

}
